import { render } from "./ArticlesWorkspace.vue?vue&type=template&id=3e209bc3&scoped=true"
import script from "./ArticlesWorkspace.vue?vue&type=script&lang=js"
export * from "./ArticlesWorkspace.vue?vue&type=script&lang=js"

import "./ArticlesWorkspace.vue?vue&type=style&index=0&id=3e209bc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e209bc3"]])

export default __exports__